export enum UserRole {
  user = 'user',
  admin = 'admin',
}
